<template>
    <div id="vue-modal" class="modal">
        <div class="mask"></div>
        <div class="modal-content">
            <div class="modal-text">
                <p v-if="title">{{title}}</p>
                <p>{{content || '提示'}}</p>
            </div>
            <div class="modal-btn">
                <button @click="cancelMethod" v-if="cancel">{{cancelText}}</button><button @click="submitMethod" :style="'color:'+active">{{submitText}}</button>
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    data(){
        return{
            title:'',
            content:'',
            cancel:true,
            cancelText:'取消',
            submitText:'确定',
            active:'#ff5500',
        }
    },
    methods:{
        submitMethod(){},
        cancelMethod(){},
    },
    mounted(){
        let existEle = document.querySelector("#vue-modal");
        if (existEle) {
            document.body.removeChild(existEle);
        }
    }
}
</script>

<style>
.modal{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
}
.mask{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0,.5);
}
.modal-content{
    padding-top: 20px;
    min-width: 200px;
    position: absolute;
    text-align: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    z-index: 1;
}
.modal-text p{
    padding-bottom: 20px;
}
.modal-btn{
    position: relative;
    display: flex;
}
.modal-btn:before{
    content: "";
    height: 1px;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #efefef;
    transform: scale(1,.5)
}
.modal-content button{
    flex: 1;
    padding: 0;
    margin: 0;
    height: 40px;
    line-height: 30px;
    border: 0;
    background-color: transparent;
    position: relative;
}
.modal-content button:nth-child(2)::before{
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 1px;
    transform: scale(.3,1);
    background-color: #efefef;
}
</style>




// WEBPACK FOOTER //
// src/components/vue-modal/index.vue